/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_Found_Back_HomeInputs */

const en_common_not_found_back_home = /** @type {(inputs: Common_Not_Found_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Common_Not_Found_Back_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_not_found_back_home = /** @type {((inputs?: Common_Not_Found_Back_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_Found_Back_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_not_found_back_home(inputs)
});
export { common_not_found_back_home as "common.not_found.back_home" }